import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from 'src/app/modules/shared-modules/material.module';
import { CustomButtonComponent } from './custom-button/custom-button.component';
import { CardButtonComponent } from './card-button/card-button.component';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ContentCardComponent } from './content-card/content-card.component';
import { CustomIconComponent } from './custom-icon/custom-icon.component';
import { ItemPaginatorComponent } from './item-paginator/item-paginator.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatPaginatorIntlCustom } from './custom-paginator/custom-paginator';

@NgModule({
    exports: [
        CustomButtonComponent,
        CardButtonComponent,
        ContentCardComponent,
        CustomIconComponent,
        ItemPaginatorComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        BrowserModule,
        RouterModule,
        CustomButtonComponent,
        CardButtonComponent,
        ContentCardComponent,
        CustomIconComponent,
        ItemPaginatorComponent
    ],
    providers: [
        { provide: MatPaginatorIntl, useClass: MatPaginatorIntlCustom }
    ]
})
export class SharedModule { }
